import { BasicEntity } from "../../../core/models/basic-entity";

export class Country extends BasicEntity {
    public IsVisible?:boolean;
    
    constructor(country?: Partial<Country>) {
        super(country);
        Object.assign(this, country);
    }
}